// src/onus_components/WanAccessModal.jsx — abrir o cerrar la web de la ONT desde la WAN
//
// Habilita la página de administración de la ONT por su lado de internet,
// para entrar a diagnosticar. Se hace desde `diagnose` en la OLT.

import React, { useEffect, useState } from "react";
import { authFetch } from "../utils/authFetch";
import { Iconos } from "../componentes/base";
import ModalPasos, { fichaOnu, leerRespuesta, ubicacionDe } from "../componentes/olt/ModalPasos";

export default function WanAccessModal({ open, onu, onClose, onSuccess }) {
  const [habilitar, setHabilitar] = useState(true);
  const [estado, setEstado] = useState("reposo");
  const [salida, setSalida] = useState([]);
  const [error, setError] = useState("");

  const u = ubicacionDe(onu);
  const accion = habilitar ? "enable" : "disable";

  useEffect(() => {
    if (!open) return;
    setEstado("reposo"); setSalida([]); setError(""); setHabilitar(true);
  }, [open, onu?.id]);

  async function ejecutar() {
    if (!onu?.id) return;
    setEstado("corriendo"); setSalida([]); setError("");
    try {
      const res = await authFetch(`/api/onus/${onu.id}/wan_access_http`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ enable: habilitar }),
      });
      const data = await leerRespuesta(res);
      setSalida(Array.isArray(data?.outputs) ? data.outputs : []);
      if (!res.ok || !data?.ok) throw new Error(data?.mensaje || "No se pudo cambiar el acceso web.");
      onSuccess?.(data?.mensaje || (habilitar ? "Acceso web habilitado" : "Acceso web cerrado"));
    } catch (e) {
      setError(String(e?.message || e));
    } finally {
      setEstado("fin");
    }
  }

  return (
    <ModalPasos
      abierto={open}
      titulo="Acceso web de la ONT"
      icono={Iconos.equipos}
      ficha={fichaOnu(onu)}
      aviso={habilitar
        ? "Abre la página de administración de la ONT desde su WAN, para entrar a diagnosticar. Ciérrala al terminar: deja la ONT expuesta a internet."
        : "Cierra la página de administración de la ONT por la WAN. Es lo que hay que hacer al terminar un diagnóstico."}
      verbo={habilitar ? "Abrir acceso web" : "Cerrar acceso web"}
      estado={estado}
      salida={salida}
      error={error}
      mensaje={habilitar ? "Acceso web abierto. Recuerda cerrarlo al terminar." : "Acceso web cerrado."}
      fases={[
        { rotulo: "Entrar a diagnose", coincide: /^diagnose$/, cmds: ["diagnose"] },
        { rotulo: habilitar ? "Abrir HTTP en la WAN" : "Cerrar HTTP en la WAN", coincide: /^ont wan-access/, cmds: [`ont wan-access http ${u.fsp} ${u.ont} ${accion}`] },
        { rotulo: "Salir de diagnose", coincide: /^quit$/, cmds: ["quit"] },
      ]}
      onEjecutar={ejecutar}
      onCerrar={onClose}
    >
      <div className="mp-campos">
        <label className="mp-campo">
          <span>Qué hacer</span>
          <select value={habilitar ? "1" : "0"} onChange={(e) => setHabilitar(e.target.value === "1")}>
            <option value="1">Abrir el acceso web</option>
            <option value="0">Cerrar el acceso web</option>
          </select>
        </label>
      </div>
    </ModalPasos>
  );
}
